import * as z from "zod";

export const RecognizeSegmentOption = z.object({
  _id: z.string(),
  name: z.string(),
});
export type RecognizeSegmentOption = z.infer<typeof RecognizeSegmentOption>;

export const getRecognizeSegments = {
  name: "getRecognizeSegments" as const,
  input: z.object({}),
  output: z.object({ segments: z.array(RecognizeSegmentOption) }),
};
